import * as qs from "qs";
import * as React from "react";
import APIClient from "./APIClient";
import { Button } from "react-bootstrap";

interface AddressValidatorProps {
  address_line1: string;
  address_line2: string;
  city: string;
  state: string;
  postal_code: string;
  callback: Function;
}

class AddressValidator extends React.Component<AddressValidatorProps, any> {
  _isMounted: Boolean;
  constructor(props: AddressValidatorProps) {
    super(props);
    this.state = {
      address_line1: "",
      address_line2: "",
      city: "",
      state: "",
      postal_code: "",
      address_confirmed: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  static addressPayload(props) {
    const payload: any = {};
    payload.address1 = props.address_line1;
    payload.address2 = props.address_line2;
    payload.city = props.city;
    payload.state = props.state;
    payload.zip = props.postal_code;
    return payload;
  }

  validateAddress(props) {
    APIClient.get(
      `/addresses/validate?${qs.stringify(AddressValidator.addressPayload(props))}`,
    ).then((responseObject: any) => {
      if (responseObject.address && this._isMounted) {
        const { line1, line2, city, state, postal_code, plus_four } = responseObject.address;
        const newState = {
          address_line1: line1,
          address_line2: line2,
          city,
          state,
          postal_code: [postal_code, plus_four].filter(z => z).join("-"),
        };
        this.setState(newState);
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.shouldVerifyAddress(nextProps)) {
      this.validateAddress(nextProps);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState !== this.state;
  }

  shouldVerifyAddress(nextProps) {
    if (
      (this.state.address_line1 !== nextProps.address_line1 ||
        this.state.address_line2 !== nextProps.address_line2 ||
        this.state.city !== nextProps.city ||
        this.state.state !== nextProps.state ||
        this.state.postal_code !== nextProps.postal_code) &&
      nextProps.address_line1 &&
      ((nextProps.postal_code && nextProps.postal_code.length >= 5) ||
        (nextProps.city && nextProps.state && nextProps.state.length === 2))
    ) {
      this.setState({ address_confirmed: false });
      return true;
    }
    return false;
  }

  updateAddress() {
    this.props.callback(this.state);
    this.setState({ address_confirmed: true });
  }

  validatedAddressDoesNotMatch() {
    this.setState({ address_confirmed: true });
  }

  render() {
    if (this.state.address_confirmed || this.state.address_line1 === "") {
      return <div />;
    }
    return (
      <div className="alert alert-warning">
        <p>We found:</p>
        <ul className="address">
          <li>{this.state.address_line1}</li>
          <li>{this.state.address_line2}</li>
          <li>
            {this.state.city}, {this.state.state} {this.state.postal_code}
          </li>
        </ul>
        <br />
        <div className="button-menu horizontal">
          <Button className="useThisAddress" onClick={this.updateAddress.bind(this)}>
            Use this address
          </Button>
          <Button className="useOriginal" onClick={this.validatedAddressDoesNotMatch.bind(this)}>
            Use my original address
          </Button>
        </div>
      </div>
    );
  }
}

export default AddressValidator;
